module.exports = __webpack_public_path__ + "static/img/qualifications_row_10.a6e7f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_10.png
// module id = YAZV
// module chunks = 1